import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Menu } from 'primereact/menu';
import { OverlayPanel } from 'primereact/overlaypanel';
import { classNames } from 'primereact/utils';
import ColumnForm from './ColumnForm.js';
import { getDataTypeIcon } from '../helpers/utils.js';
import './ColumnHeader.css.js';

const ColumnHeader = ({ column, onAddColumnRight, onDelete, onDuplicate, onUpdate }) => {
    const button = useRef();
    const menu = useRef();
    const editOverlayPanel = useRef();
    const addRightOverlayPanel = useRef();
    const [menuShow, setMenuShow] = useState(false);
    const [deleteConfirmDialogVisible, setDeleteConfirmDialogVisible] = useState(false);
    const [duplicateConfirmDialogVisible, setDuplicateConfirmDialogVisible] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: classNames("c2-data-model-table-column-header", "flex align-items-center") },
            React.createElement("span", { className: classNames(getDataTypeIcon(column.dataType), "mr-2") }),
            column.fieldName,
            React.createElement(Button, { className: "p-button-icon p-button-text p-button-sm p-0 ml-auto", icon: `pi pi-angle-${menuShow ? "up" : "down"}`, onClick: (event) => {
                    var _a, _b, _c;
                    (_a = menu.current) === null || _a === void 0 ? void 0 : _a.toggle(event);
                    (_b = addRightOverlayPanel.current) === null || _b === void 0 ? void 0 : _b.hide();
                    (_c = editOverlayPanel.current) === null || _c === void 0 ? void 0 : _c.hide();
                }, ref: button }),
            React.createElement(Menu, { model: modelsFactory(), onHide: () => setMenuShow(false), onShow: () => setMenuShow(true), popup: true, ref: menu })),
        React.createElement(OverlayPanel, { className: "c2-data-model-table-column-header__op border-round", ref: editOverlayPanel },
            React.createElement(ColumnForm, { initialModel: column, mode: "update", onCancel: () => editOverlayPanel.current.hide(), onCreate: (model) => {
                    editOverlayPanel.current.hide();
                    onAddColumnRight({ column, model });
                }, onUpdate: (model) => {
                    editOverlayPanel.current.hide();
                    onUpdate({ column, model });
                } })),
        React.createElement(OverlayPanel, { className: "c2-data-model-table-column-header__op border-round", ref: addRightOverlayPanel },
            React.createElement(ColumnForm, { onCancel: () => addRightOverlayPanel.current.hide(), onCreate: (model) => {
                    addRightOverlayPanel.current.hide();
                    onAddColumnRight({ column, model });
                } })),
        React.createElement(ConfirmDialog, { accept: () => {
                onDuplicate({ column });
                setDuplicateConfirmDialogVisible(false);
            }, icon: "pi pi-exclamation-triangle", header: "Confirm", message: `Do you really want to duplicate ${column.fieldName} column?`, onHide: () => setDuplicateConfirmDialogVisible(false), reject: () => setDuplicateConfirmDialogVisible(false), visible: duplicateConfirmDialogVisible }),
        React.createElement(ConfirmDialog, { accept: () => {
                onDelete({ column });
                setDeleteConfirmDialogVisible(false);
            }, icon: "pi pi-exclamation-triangle", header: "Confirm", message: `Do you really want to delete ${column.fieldName} column?`, onHide: () => setDeleteConfirmDialogVisible(false), reject: () => setDeleteConfirmDialogVisible(false), visible: deleteConfirmDialogVisible })));
    function modelsFactory() {
        return [
            {
                label: "Edit",
                icon: "pi pi-pencil",
                command: () => {
                    setTimeout(() => { var _a; return (_a = editOverlayPanel.current) === null || _a === void 0 ? void 0 : _a.show({ target: button.current }); }, 0);
                },
            },
            {
                label: "Duplicate",
                icon: "pi pi-clone",
                command: () => {
                    setDuplicateConfirmDialogVisible(true);
                },
            },
            {
                label: "Add Column Right",
                icon: "pi pi-plus",
                command: () => {
                    setTimeout(() => { var _a; return (_a = addRightOverlayPanel.current) === null || _a === void 0 ? void 0 : _a.show({ target: button.current }); }, 0);
                },
            },
            { separator: true },
            {
                label: "Delete",
                icon: "pi pi-trash",
                command: () => {
                    setDeleteConfirmDialogVisible(true);
                },
            },
        ];
    }
};

export { ColumnHeader as default };
//# sourceMappingURL=ColumnHeader.js.map
